"use client";

import Link from "next/link";
import { Article } from "./articles/Article";
import { Box, Typography } from "@mui/material";

export function HubListingArticle({ article }: { article: Article }) {
  return (
    <Box
      component={Link}
      key={article.title}
      href={`/hub/guides/${article.slug}`}
      sx={{
        display: "grid",
        //gridTemplateColumns: "150px 1fr",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "auto",
        // rowGap: 0.5
        // columnGap: 2,
      }}
    >
      {/* <Box
        sx={{
          width: "150px",
          height: "100px",
          backgroundColor: "grey.300",
          gridColumn: 1,
          gridRow: "span 3",
        }}
      /> */}
      <Box
        sx={{
          gridColumn: 2,
          gridRow: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          variant="caption"
          sx={(theme) => ({
            border: "1px solid",
            borderColor: "grey.200",
            padding: theme.spacing(0.5, 1),
            borderRadius: 2,
            fontWeight: "bold",
            width: "fit-content",
          })}
        >
          GUIDES
        </Typography>
        <Typography variant="caption">
          &nbsp;&nbsp;·&nbsp;&nbsp;
          {article.createdAt}
        </Typography>
      </Box>
      <Typography
        variant="h6"
        component="h2"
        sx={{ fontWeight: "bold", gridColumn: 2, gridRow: 2, margin: 0 }}
      >
        {article.title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          gridColumn: 2,
          gridRow: 3,
        }}
      >
        {article.preview}...
      </Typography>
    </Box>
  );
}
